// extracted by mini-css-extract-plugin
export var addButton = "_oq-0";
export var border = "_oq-8";
export var check = "_oq-h";
export var danger = "_oq-6";
export var dropdownContainer = "_oq-1";
export var editModalBody = "_oq-j";
export var footerContainer = "_oq-i";
export var fullWidth = "_oq-a";
export var hide = "_oq-9";
export var icon = "_oq-3";
export var input = "_oq-7";
export var inputFlex = "_oq-b";
export var inputWrapper = "_oq-c";
export var manualFocus = "_oq-5";
export var optionButton = "_oq-4";
export var pillWrapper = "_oq-e";
export var pointer = "_oq-2";
export var showOverflow = "_oq-f";
export var tagsFlex = "_oq-d";
export var xButton = "_oq-g";